{
  "{{count}} floors selected_one": "{{count}} floor selected",
  "{{count}} floors selected_other": "{{count}} floors selected",
  "{{count}} minutes_one": "{{count}} minute",
  "{{count}} minutes_other": "{{count}} minutes",
  "{{count}} remarks_one": "{{count}} remark",
  "{{count}} remarks_other": "{{count}} remarks",
  "{{count}} selected_one": "{{count}} selected",
  "{{count}} selected_other": "{{count}} selected",
  "{{count}} statuses selected_one": "{{count}} status selected",
  "{{count}} statuses selected_other": "{{count}} statuses selected",
  "{{count}} workspace types selected_one": "{{count}} workspace type selected",
  "{{count}} workspace types selected_other": "{{count}} workspace types selected",
  "{{count}} workspaces_one": "{{count}} workspace",
  "{{count}} workspaces_other": "{{count}} workspaces",
  "{{numberOfUnused}} out of {{count}} workspaces were not used {{period}}._one": "{{numberOfUnused}} out of {{count}} workspace were not used {{period}}.",
  "{{numberOfUnused}} out of {{count}} workspaces were not used {{period}}._other": "{{numberOfUnused}} out of {{count}} workspaces were not used {{period}}",
  "{{page}} of {{numberOfPages}}": "{{page}} of {{numberOfPages}}",
  "{{part}} not connected": "{{part}} not connected",
  "{{time}} ago": "{{time}} ago",
  "A company is used in this application as a container for multiple locations.": "A company is used in this application as a container for multiple locations.",
  "A new password is required": "A new password is required",
  "A password is required": "A password is required",
  "A recovery email with resetlink has been sent": "A recovery email with resetlink has been sent",
  "Access to bluetooth is not granted. Please allow access to bluetooth and try again.": "Access to bluetooth is not granted. Please allow access to bluetooth and try again.",
  "Access to location services is not granted. Please turn location services on and try again.": "Access to location services is not granted. Please turn location services on and try again.",
  "Access to:": "Access to:",
  "Account": "Account",
  "Action": "Action",
  "Active": "Active",
  "Active on <1></1>": "Active on <1></1>",
  "Active users": "Active users",
  "Activities": "Activities",
  "Add": "Add",
  "Add a visual impression of the building. This image will be visible on the homepage and on the dashboard.": "Add a visual impression of the building. This image will be visible on the homepage and on the dashboard.",
  "Add address manually": "Add address manually",
  "Add building": "Add building",
  "Add device": "Add device",
  "Add floor": "Add floor",
  "Add floors to specify your location and manage your floorplans.": "Add floors to specify your location and manage your floorplans.",
  "Add location": "Add location",
  "Add manually": "Add manually",
  "Add map": "Add map",
  "Add photo": "Add photo",
  "Add remark": "Add remark",
  "Add schedule": "Add schedule",
  "Add selection": "Add selection",
  "Add workspace": "Add workspace",
  "Add workspaces": "Add workspaces",
  "Add workspaces to zone": "Add workspaces to zone",
  "Add your first building and it will be listed here.": "Add your first building and it will be listed here.",
  "Add your first device and it will be listed here...": "Add your first device and it will be listed here...",
  "Add your first location and it will be listed here.": "Add your first location and it will be listed here.",
  "Add your first remark and it will be listed here...": "Add your first remark and it will be listed here...",
  "Add your first schedule and it will be listed here...": "Add your first schedule and it will be listed here...",
  "Add your first workspace and it will be listed here...": "Add your first workspace and it will be listed here...",
  "Add your first workspace type and it will be listed here...": "Add your first workspace type and it will be listed here...",
  "Add your first zone and it will be listed here...": "Add your first zone and it will be listed here...",
  "Added {{date}}": "Added {{date}}",
  "Adding workspaces to the workspace library on the left will automatically add them to other pages on the platform, to ensure consistency over the entire platform.": "Adding workspaces to the workspace library on the left will automatically add them to other pages on the platform, to ensure consistency over the entire platform.",
  "Address": "Address",
  "Address is required": "Address is required",
  "Address line 1": "Address line 1",
  "Address line 2": "Address line 2",
  "Address not found": "Address not found",
  "Administrator": "Administrator",
  "Advanced company settings": "Advanced company settings",
  "Advanced settings": "Advanced settings",
  "After you have invited users, they will be listed here for user management...": "After you have invited users, they will be listed here for user management...",
  "All days": "All days",
  "All floors": "All floors",
  "All locations": "All locations",
  "All workspaces": "All workspaces",
  "All workspaces ever added to this floor are listed here. Changes in the workspace library affect pages and features that use workspaces.": "All workspaces ever added to this floor are listed here. Changes in the workspace library affect pages and features that use workspaces.",
  "An email address is required": "An email address is required",
  "An unknown error occurred. Please try again.": "An unknown error occurred. Please try again.",
  "Any floor": "Any floor",
  "Any status": "Any status",
  "Any workspace type": "Any workspace type",
  "Are you sure you want to remove this installation?": "Are you sure you want to remove this installation?",
  "Article number": "Article number",
  "At the busiest moment {{period}}, we measured {{value}}% of the workspaces as occupied.": "At the busiest moment {{period}}, we measured {{value}}% of the workspaces as occupied.",
  "Available": "Available",
  "Average": "Average",
  "Average occupancy": "Average occupancy",
  "Average occupancy over time": "Average occupancy over time",
  "Band": "Band",
  "Band is required": "Band is required",
  "Battery state": "Battery state",
  "Beacon": "Beacon",
  "Beacon details": "Beacon details",
  "between {{start}} and {{end}}": "between {{start}} and {{end}}",
  "Blocked": "Blocked",
  "Blocked mode": "Blocked mode",
  "Building": "Building",
  "Building could not be created": "Building could not be created",
  "Building could not be deleted": "Building could not be deleted",
  "Building could not be saved": "Building could not be saved",
  "Building details": "Building details",
  "Building image could not be uploaded": "Building image could not be uploaded",
  "Building is required": "Building is required",
  "Building name": "Building name",
  "Building name is required": "Building name is required",
  "Building was created successfully": "Building was created successfully",
  "Building was deleted successfully": "Building was deleted successfully",
  "Building was updated successfully": "Building was updated successfully",
  "Buildings": "Buildings",
  "Buildings per page": "Buildings per page",
  "By bluetooth": "By bluetooth",
  "By floor": "By floor",
  "By picking another company the device will be transferred to the chosen company. The device will not be visible within the current company anymore.": "By picking another company the device will be transferred to the chosen company. The device will not be visible within the current company anymore.",
  "By weekday": "By weekday",
  "By workspace type": "By workspace type",
  "By zone": "By zone",
  "Cancel": "Cancel",
  "Cancel installation": "Cancel installation",
  "Change": "Change",
  "Change email address": "Change email address",
  "Change password": "Change password",
  "Changes were made to one or more fields in this form. Please decide if you want to keep these changes or not.": "Changes were made to one or more fields in this form. Please decide if you want to keep these changes or not.",
  "Changes were succesfully saved": "Changes were succesfully saved",
  "Charger": "Charger",
  "Charger beacons settings correct": "Charger beacons settings correct",
  "Charger broadcast name correct": "Charger broadcast name correct",
  "Charger broadcasts beacon": "Charger broadcasts beacon",
  "Charger can connect": "Charger can connect",
  "Charger diagnostics correct": "Charger diagnostics correct",
  "Charger is charging": "Charger is charging",
  "Charger not found": "Charger not found",
  "Charging": "Charging",
  "Choose a type and click on floorplan to position the workspace": "Choose a type and click on floorplan to position the workspace",
  "Choose from library": "Choose from library",
  "Choose new password": "Choose new password",
  "Choose password": "Choose password",
  "City": "City",
  "City is required": "City is required",
  "Cleaning": "Cleaning",
  "Cleaning mode": "Cleaning mode",
  "Clear filters": "Clear filters",
  "Click on floorplan to position the workspace": "Click on floorplan to position the workspace",
  "Click on the floorplan on to draw a line of which you can give the correct dimensions. Tip: larger measure will result in more accurate scaling. Select for example a wall that is measured to be at least 500 cm.": "Click on the floorplan on to draw a line of which you can give the correct dimensions. Tip: larger measure will result in more accurate scaling. Select for example a wall that is measured to be at least 500 cm.",
  "Click the link contained in the e-mail. You will be forwarded to a page where you can reset your password. The link in the e-mail will expire in 2 hours from now.": "Click the link contained in the e-mail. You will be forwarded to a page where you can reset your password. The link in the e-mail will expire in 2 hours from now.",
  "cm": "cm",
  "Co-working": "Co-working",
  "Companies": "Companies",
  "Companies data could not be loaded": "Companies data could not be loaded",
  "Companies per page": "Companies per page",
  "Company": "Company",
  "Company could not be created": "Company could not be created",
  "Company could not be deleted": "Company could not be deleted",
  "Company could not be saved": "Company could not be saved",
  "Company details": "Company details",
  "Company is required": "Company is required",
  "Company name": "Company name",
  "Company name is required": "Company name is required",
  "Company vitality could not be saved": "Company vitality could not be saved",
  "Company vitality was updated successfully": "Company vitality was updated successfully",
  "Company was created successfully": "Company was created successfully",
  "Company was deleted successfully": "Company was deleted successfully",
  "Company was updated successfully": "Company was updated successfully",
  "Complete installation": "Complete installation",
  "Completed": "Completed",
  "Configured webhooks": "Configured webhooks",
  "Connected": "Connected",
  "Connected device": "Connected device",
  "Connected devices": "Connected devices",
  "Connection lost": "Connection lost",
  "Connection to the charger failed. Please try again.": "Connection to the charger failed. Please try again.",
  "Connectivity": "Connectivity",
  "Continue": "Continue",
  "Continue editing": "Continue editing",
  "Country": "Country",
  "Country is required": "Country is required",
  "Create a password that:": "Create a password that:",
  "Create company": "Create company",
  "Create new company": "Create new company",
  "Create new zone": "Create new zone",
  "Create workspace type": "Create workspace type",
  "Create zone": "Create zone",
  "CSQ": "CSQ",
  "Current company": "Current company",
  "Current password": "Current password",
  "Currently set to <1>{{time}}</1>": "Currently set to <1>{{time}}</1>",
  "Custom": "Custom",
  "Daily": "Daily",
  "Date": "Date",
  "Date created": "Date created",
  "Define the name of the building where you want to start adding workspaces and devices to.": "Define the name of the building where you want to start adding workspaces and devices to.",
  "Define the name of the location where you want to start adding workspaces and devices to.": "Define the name of the location where you want to start adding workspaces and devices to.",
  "Defining the company locations a user has access to in the application": "Defining the company locations this user has access to in the application",
  "Delete {{entity}}": "Delete {{entity}}",
  "Delete building": "Delete building",
  "Delete company": "Delete company",
  "Delete device": "Delete device",
  "Delete draft": "Delete draft",
  "Delete image": "Delete image",
  "Delete location": "Delete location",
  "Delete my user profile": "Delete my user profile",
  "Delete schedule": "Delete schedule",
  "Delete workspace": "Delete workspace",
  "Delete workspace type": "Delete workspace type",
  "Delete zone": "Delete zone",
  "Describe the intended use for this zone. For example: used as dashboard filter, settings etcetera.": "Describe the intended use for this zone. For example: used as dashboard filter, settings etcetera.",
  "Description": "Description",
  "Device": "Device",
  "Device could not be created": "Device could not be created",
  "Device could not be deleted": "Device could not be deleted",
  "Device could not be saved": "Device could not be saved",
  "Device could not be transfered": "Device could not be transfered",
  "Device could not be uninstalled": "Device could not be uninstalled",
  "Device details": "Device details",
  "Device installed": "Device installed",
  "Device is attached and sending a package": "Device is attached and sending a package",
  "Device is attached and waiting for a package": "Device is attached and waiting for a package",
  "Device is attached but there was an error sending a package": "Device is attached but there was an error sending a package",
  "Device is not attached due to an error": "Device is not attached due to an error",
  "Device is powering up and will attach to the network soon": "Device is powering up and will attach to the network soon",
  "Device is waiting for power supply to be sufficient": "Device is waiting for power supply to be sufficient",
  "Device location": "Device location",
  "Device state is unknown": "Device state is unknown",
  "Device status": "Device status",
  "Device was created successfully": "Device was created successfully",
  "Device was deleted successfully": "Device was deleted successfully",
  "Device was transfered successfully": "Device was transfered successfully",
  "Device was uninstalled successfully": "Device was uninstalled successfully",
  "Device was updated successfully": "Device was updated successfully",
  "Devices": "Devices",
  "Diagnostic": "Diagnostic",
  "Did you remove the phone from the charger and turn the power off and on?": "Did you remove the phone from the charger and turn the power off and on?",
  "Disconnected": "Disconnected",
  "Doctor": "Doctor",
  "Don't place your phone on the device": "Don't place your phone on the device",
  "Don't save changes": "Don't save changes",
  "Don't switch of the device! It will restart automatically after the update is complete.": "Don't switch of the device! It will restart automatically after the update is complete.",
  "Download": "Download",
  "Download data": "Download data",
  "Download floorplan": "Download floorplan",
  "Download graph": "Download graph",
  "Download heatmap": "Download heatmap",
  "Download options": "Download options",
  "Draft": "Draft",
  "Drag and drop or <2>Choose file</2> to upload": "Drag and drop or <2>Choose file</2> to upload",
  "Drag and drop or click to upload": "Drag and drop or click to upload",
  "Drop the file here": "Drop the file here",
  "Dutch": "Dutch",
  "Edit": "Edit",
  "Edit details": "Edit details",
  "Email": "Email",
  "Email address": "Email address",
  "Email address is required": "Email address is required",
  "Email could not be updated": "Email could not be updated",
  "Email was updated successfully": "Email was updated successfully",
  "Enabling the Zens legacy occupancy colouring will make the Led-ring on the PuK devices light up green when the workspace is free to use and red when the workspace is occupied. This mode is different from the newly implemented default mode, in which the Led is turned off unless a specific message needs to be communicated to the user. Activating this mode will turn on the legacy setting for the devices, which means it should not be used for newly added companies. When activated, this mode applies to all devices in the company.": "Enabling the Zens legacy occupancy colouring will make the Led-ring on the PuK devices light up green when the workspace is free to use and red when the workspace is occupied. This mode is different from the newly implemented default mode, in which the Led is turned off unless a specific message needs to be communicated to the user. Activating this mode will turn on the legacy setting for the devices, which means it should not be used for newly added companies. When activated, this mode applies to all devices in the company.",
  "Enabling the Zens Vitality mode will make the Led-ring on your PuK devices blink in green for 2 minutes when it notices you have been at your desk for a while. This blinking reminds you to to take another stance, have a mini break and recharge. When activated, this mode applies to all devices in your company.": "Enabling the Zens Vitality mode will make the Led-ring on your PuK devices blink in green for 2 minutes when it notices you have been at your desk for a while. This blinking reminds you to to take another stance, have a mini break and recharge. When activated, this mode applies to all devices in your company.",
  "English": "English",
  "Enter your email address": "Enter your email address",
  "Enter your email here": "Enter your email here",
  "Enter your name here": "Enter your name here",
  "Enter your password here": "Enter your password here",
  "Error": "Error",
  "Error generating data": "Error generating data",
  "Error generating graph": "Error generating graph",
  "Error generating heatmap": "Error generating heatmap",
  "Error message": "Error message",
  "Expected beacon {{expected}} but found {{found}}.": "Expected beacon {{expected}} but found {{found}}.",
  "Expected device {{expected}} but found {{found}}.": "Expected device {{expected}} but found {{found}}.",
  "External": "External",
  "Facilitator": "Facilitator",
  "Failed to find charger with bluetooth": "Failed to find charger with bluetooth",
  "Filters": "Filters",
  "Find location": "Find location",
  "Find location via Maps": "Find location via Maps",
  "Firmware": "Firmware",
  "Firmware update": "Firmware update",
  "Firmware version": "Firmware version",
  "Floor": "Floor",
  "Floor_one": "Floor",
  "Floor_other": "Floors",
  "Floor could not be added": "Floor could not be added",
  "Floor could not be deleted": "Floor could not be deleted",
  "Floor could not be saved": "Floor could not be saved",
  "Floor details": "Floor details",
  "Floor is required": "Floor is required",
  "Floor level": "Floor level",
  "Floor level is required": "Floor level is required",
  "Floor name": "Floor name",
  "Floor settings": "Floor settings",
  "Floor was added successfully": "Floor was added successfully",
  "Floor was deleted successfully": "Floor was deleted successfully",
  "Floorplan": "Floorplan",
  "Floorplan background could not be uploaded": "Floorplan background could not be uploaded",
  "Floorplan could not be published": "Floorplan could not be published",
  "Floorplan could not be saved": "Floorplan could not be saved",
  "Floorplan draft could not be deleted": "Floorplan draft could not be deleted",
  "Floorplan editor": "Floorplan editor",
  "Floorplan options": "Floorplan options",
  "Floorplan was discarded successfully": "Floorplan was discarded successfully",
  "Floorplan was published successfully": "Floorplan was published successfully",
  "Floorplan was saved as draft successfully": "Floorplan was saved as draft successfully",
  "Floorplan was updated successfully": "Floorplan was updated successfully",
  "Floors": "Floors",
  "Following errors were found during import": "Following errors were found during import",
  "Forbidden": "Forbidden",
  "Forgot password?": "Forgot password?",
  "Found charger": "Found charger",
  "Free": "Free",
  "Friday": "Friday",
  "From": "From",
  "Full": "Full",
  "Full name": "Full name",
  "General details": "General details",
  "General information": "General information",
  "Got it": "Got it",
  "Has at least 1 number": "Has at least 1 number",
  "Has at least 6 characters": "Has at least 6 characters",
  "Has uppercase and lowercase letters": "Has uppercase and lowercase letters",
  "Historical heatmap": "Historical heatmap",
  "Hold Shift to select multiple workspaces.": "Hold Shift to select multiple workspaces.",
  "Hold time": "Hold time",
  "Home": "Home",
  "Hourly": "Hourly",
  "I would like to add a first location for this company": "I would like to add a first location for this company",
  "If an account exists, an email with the link to reset your password has been sent to <2>{{email}}</2>": "If an account exists, an email with the link to reset your password has been sent to <2>{{email}}</2>",
  "Image selection failed": "Image selection failed",
  "Image too large": "Image too large",
  "Image too small": "Image too small",
  "Image type must be JPG, PNG or BMP": "Image type must be JPG, PNG or BMP",
  "Image type must be SVG": "Image type must be SVG",
  "IMEI": "IMEI",
  "IMEI is required": "IMEI is required",
  "Inactive": "Inactive",
  "Regular sync": "Regular sync",
  "Enabling the regular sync will make the PuK devices sync with the server at regular intervals. This is useful for faster dispatch of new instructions to the devices. When activated, this mode applies to all devices in the company.": "Enabling the regular sync will make the PuK devices sync with the server at regular intervals. This is useful for faster dispatch of new instructions to the devices. When activated, this mode applies to all devices in the company.",
  "Indicates the of firmware version embedded into the device.": "Indicates the of firmware version embedded into the device.",
  "Indicates whether a Led-ring is connected (1) or not (0).": "Indicates whether a Led-ring is connected (1) or not (0).",
  "Indicates whether a new PDP session was initiated for this transmission (1) or not (0).": "Indicates whether a new PDP session was initiated for this transmission (1) or not (0).",
  "Indicates whether all workspace peripherals are connected and functioning as expected. If a device is not online, this status will be reported as unknown.": "Indicates whether all workspace peripherals are connected and functioning as expected. If a device is not online, this status will be reported as unknown.",
  "Indicates whether the device had a new power cycle (1) or not (0).": "Indicates whether the device had a new power cycle (1) or not (0).",
  "Indicates whether the device is used for wireless charging (1) or not (0).": "Indicates whether the device is used for wireless charging (1) or not (0).",
  "Indicates whether the presence sensor is connected (1) or not (0).": "Indicates whether the presence sensor is connected (1) or not (0).",
  "Indicates whether the sensor detects presence (1) or not (0).": "Indicates whether the sensor detects presence (1) or not (0).",
  "Insights": "Insights",
  "Install a device": "Install a device",
  "Install the charger and power on. Wait for Ledring to turn green.": "Install the charger and power on. Wait for Ledring to turn green.",
  "Installation": "Installation",
  "Installed": "Installed",
  "Installed or not installed": "Installed or not installed",
  "Instructions": "Instructions",
  "Invalid charger": "Invalid charger",
  "Invalid charger beacon found. Verify that the selected device is correct and try again.": "Invalid charger beacon found. Verify that the selected device is correct and try again.",
  "Invalid date": "Invalid date",
  "Invalid email address": "Invalid email address",
  "Invalid line length": "Invalid line length",
  "Invalid major value": "Invalid major value",
  "Invalid minor value": "Invalid minor value",
  "Invalid workspace": "Invalid workspace",
  "Invitation could not be sent": "Invitation could not be sent",
  "Invitation was resent successfully": "Invitation was resent successfully",
  "Invitation was sent successfully": "Invitation was sent successfully",
  "Invite new user": "Invite new user",
  "Invited": "Invited",
  "It is important to be aware of the implications this might have. All changes to the workspace library immediately affect the features that include workspaces.": "It is important to be aware of the implications this might have. All changes to the workspace library immediately affect the features that include workspaces.",
  "JPG, PNG or BMP": "JPG, PNG or BMP",
  "Keep me signed in": "Keep me signed in",
  "Key hint for quick editing": "Key hint for quick editing",
  "Kiosk is locked successfully ": "Kiosk is locked successfully ",
  "Kiosk is unlocked successfully": "Kiosk is unlocked successfully",
  "Landscape": "Landscape",
  "Language": "Language",
  "Last acknowledged": "Last acknowledged",
  "Last changed": "Last changed",
  "Last month": "Last month",
  "Last update:": "Last update:",
  "Last week": "Last week",
  "Last year": "Last year",
  "Led": "Led",
  "Led cnnct": "Led cnnct",
  "Led connection could not be verified": "Led connection could not be verified",
  "Led disconnected": "Led disconnected",
  "Ledring is missing or not installed correctly": "Ledring is missing or not installed correctly",
  "Legacy occupancy colouring": "Legacy occupancy colouring",
  "Legacy occupancy colouring active": "Legacy occupancy colouring active",
  "Line length": "Line length",
  "Live": "Live",
  "Live status page": "Live status page",
  "Load more": "Load more",
  "Loading workspaces ({{loaded}} of {{total}})...": "Loading workspaces ({{loaded}} of {{total}})...",
  "Located at": "Located at",
  "Location": "Location",
  "Location access": "Location access",
  "Location could not be created": "Location could not be created",
  "Location could not be deleted": "Location could not be deleted",
  "Location could not be saved": "Location could not be saved",
  "Location details": "Location details",
  "Location is required": "Location is required",
  "Location name": "Location name",
  "Location name is required": "Location name is required",
  "Location of {{workspace}} on floorplan": "Location of {{workspace}} on floorplan",
  "Location was created successfully": "Location was created successfully",
  "Location was deleted successfully": "Location was deleted successfully",
  "Location was updated successfully": "Location was updated successfully",
  "Locations": "Locations",
  "Locations per page": "Locations per page",
  "Looking for beacons": "Looking for beacons",
  "Looking for chargers": "Looking for chargers",
  "Major": "Major",
  "Major is required": "Major is required",
  "Manufacturer": "Manufacturer",
  "Message": "Message",
  "Messages": "Messages",
  "Messages per page": "Messages per page",
  "Minor": "Minor",
  "Minor is required": "Minor is required",
  "Mode": "Mode",
  "Model": "Model",
  "Model is required": "Model is required",
  "Monday": "Monday",
  "Name": "Name",
  "Name is required": "Name is required",
  "Name of location": "Name of location",
  "Network": "Network",
  "Network details": "Network details",
  "Never online": "Never online",
  "New email address": "New email address",
  "New floor": "New floor",
  "New password": "New password",
  "Next": "Next",
  "No": "No",
  "No access to camera": "No access to camera",
  "No activities": "No activities",
  "No bluetooth devices found. Please try again.": "No bluetooth devices found. Please try again.",
  "No charger found": "No charger found",
  "No charger found. Please try again.": "No charger found. Please try again.",
  "No chargers were found. Please try again.": "No chargers were found. Please try again.",
  "No device installed": "No device installed",
  "No devices found": "No devices found",
  "No devices installed yet": "No devices installed yet",
  "No filters": "No filters",
  "No firmware found": "No firmware found",
  "No floorplan found": "No floorplan found",
  "No floorplan uploaded yet": "No floorplan uploaded yet",
  "No hold time": "No hold time",
  "No remarks": "No remarks",
  "No remarks found": "No remarks found",
  "No remarks yet.": "No remarks yet.",
  "No results for the current filter": "No results for the current filter",
  "No results matching <2>{{search}}</2>": "No results matching <2>{{search}}</2>",
  "No webhooks configured for this company": "No webhooks configured for this company",
  "No workspaces found.": "No workspaces found.",
  "No workspaces were found. Please try again.": "No workspaces were found. Please try again.",
  "Not installed": "Not installed",
  "Occupancy": "Occupancy",
  "Occupancy (model number)": "Occupancy (model number)",
  "Occupancy by floor": "Occupancy by floor",
  "Occupancy by workspace type": "Occupancy by workspace type",
  "Occupancy by zone": "Occupancy by zone",
  "Occupancy over time": "Occupancy over time",
  "Occupancy trends": "Occupancy trends",
  "Occupied": "Occupied",
  "Offline": "Offline",
  "Offline or disconnected": "Offline or disconnected",
  "on {{day}}": "on {{day}}",
  "Online": "Online",
  "Online and connected": "Online and connected",
  "Only activity at selected weekdays will be taken into account.": "Only activity at selected weekdays will be taken into account.",
  "Only activity between {{startWorkday}} and {{endWorkday}} will be taken into account.": "Only activity between {{startWorkday}} and {{endWorkday}} will be taken into account.",
  "Only upload files in greyscale to suit workspaces": "Only upload files in greyscale to suit workspaces",
  "Operator": "Operator",
  "optional": "optional",
  "Over time": "Over time",
  "Page not found": "Page not found",
  "Password": "Password",
  "Password could not be updated": "Password could not be updated",
  "Password must be at least 6 characters": "Password must be at least 6 characters",
  "Password must contain at least one lowercase and one uppercase letter": "Password must contain at least one lowercase and one uppercase letter",
  "Password must contain at least one number": "Password must contain at least one number",
  "Password reset failed": "Password reset failed",
  "Password resetlink sent": "Password resetlink sent",
  "Password was updated successfully": "Password was updated successfully",
  "PDP": "PDP",
  "PDP cycle": "PDP cycle",
  "Peak": "Peak",
  "Peak occupancy": "Peak occupancy",
  "Peripherals": "Peripherals",
  "Phone bluetooth is switched off. Please turn it on and try again.": "Phone bluetooth is switched off. Please turn it on and try again.",
  "Phone did not start charging. Did you place the phone correctly on the charger?": "Phone did not start charging. Did you place the phone correctly on the charger?",
  "Photo": "Photo",
  "Photo attached": "Photo attached",
  "Pin": "Pin",
  "Place": "Place",
  "Place your phone on the charger": "Place your phone on the charger",
  "Place your phone on the charger to start the test": "Place your phone on the charger to start the test",
  "Please enter your email address as a confirmation that you want to proceed.": "Please enter your email address as a confirmation that you want to proceed.",
  "Portrait": "Portrait",
  "Power cycle": "Power cycle",
  "Preferences": "Preferences",
  "Preparing device for firmware update": "Preparing device for firmware update",
  "Preparing identification": "Preparing identification",
  "Product": "Product",
  "Product details": "Product details",
  "Product incomplete": "Product incomplete",
  "Product information": "Product information",
  "Product serial number": "Product serial number",
  "Products": "Products",
  "Products could not be added": "Products could not be added",
  "Products per page": "Products per page",
  "Products were added successfully": "Products were added successfully",
  "Profile": "Profile",
  "Profile and preferences": "Profile and preferences",
  "Profile could not be deleted": "Profile could not be deleted",
  "Profile could not be saved": "Profile could not be saved",
  "Profile data could not be loaded": "Profile data could not be loaded",
  "Profile was deleted successfully": "Profile was deleted successfully",
  "Profile was updated successfully": "Profile was updated successfully",
  "Properties": "Properties",
  "Provider": "Provider",
  "Provider is required": "Provider is required",
  "Prscn cnnct": "Prscn cnnct",
  "Publish": "Publish",
  "Quick access": "Quick access",
  "Reading charger data": "Reading charger data",
  "Received at": "Received at",
  "Redo": "Redo",
  "Remark": "Remark",
  "Remark text or photo is required": "Remark text or photo is required",
  "Remark was added successfully": "Remark was added successfully",
  "Remarks": "Remarks",
  "Remove floorplan": "Remove floorplan",
  "Remove installation": "Remove installation",
  "Remove phone from charger before starting the test": "Remove phone from charger before starting the test",
  "Remove phone from charger first": "Remove phone from charger first",
  "Remove user from company": "Remove user from company",
  "Remove your phone from the charger and turn the charger power off and on. After beep press update button below.": "Remove your phone from the charger and turn the charger power off and on. After beep press update button below.",
  "Repeated occupancy": "Repeated occupancy",
  "Resend invite": "Resend invite",
  "Reserved": "Reserved",
  "Reservation mode": "Reservation mode",
  "Reset password": "Reset password",
  "Restart": "Restart",
  "Returns the signal strength of the transmission of the registered network at the device. The received signal strength ranges from 0 being marginal (-113 dBm and lower) to 30 being excellent (-51 dBm and higher). Value is 99 if the signal strength is not known or not detectable.": "Returns the signal strength of the transmission of the registered network at the device. The received signal strength ranges from 0 being marginal (-113 dBm and lower) to 30 being excellent (-51 dBm and higher). Value is 99 if the signal strength is not known or not detectable.",
  "Role": "Role",
  "Role is required": "Role is required",
  "Roles": "Roles",
  "Rotate 90° left": "Rotate 90° left",
  "Rotate 90° right": "Rotate 90° right",
  "Saturday": "Saturday",
  "Save": "Save",
  "Save and exit": "Save and exit",
  "Save your changes?": "Save your changes?",
  "Scale": "Scale",
  "Scale floorplan": "Scale floorplan",
  "Scale line end is required": "Scale line end is required",
  "Scale line is required. Click on the floorplan to draw a line.": "Scale line is required. Click on the floorplan to draw a line.",
  "Scale line length is required": "Scale line length is required",
  "Scale line start is required": "Scale line start is required",
  "Scan charger": "Scan charger",
  "Scan code": "Scan code",
  "Scan workspace": "Scan workspace",
  "Schedule": "Schedule",
  "Schedule could not be created": "Schedule could not be created",
  "Schedule could not be deleted": "Schedule could not be deleted",
  "Schedule could not be updated": "Schedule could not be updated",
  "Schedule settings": "Schedule settings",
  "Schedule was created successfully": "Schedule was created successfully",
  "Schedule was deleted successfully": "Schedule was deleted successfully",
  "Schedule was updated successfully": "Schedule was updated successfully",
  "Schedules": "Schedules",
  "Schedules per page": "Schedules per page",
  "Scheduling space is required": "Scheduling space is required",
  "Search": "Search",
  "Search company name": "Search company name",
  "Search name or email": "Search name or email",
  "Search product name": "Search product name",
  "Search schedule name": "Search schedule name",
  "Search type name": "Search type name",
  "Search workspace name": "Search workspace name",
  "Search zone name": "Search zone name",
  "Searching for charger": "Searching for charger",
  "Second beacon": "Second beacon",
  "See all companies": "See all companies",
  "Select a company": "Select a company",
  "Select building": "Select building",
  "Select charger": "Select charger",
  "Select firmware": "Select firmware",
  "Select floor": "Select floor",
  "Select for which workspaces you want to schedule": "Select for which workspaces you want to schedule",
  "Select location": "Select location",
  "Select on map": "Select on map",
  "Select scheduling space": "Select scheduling space",
  "Select this mode to make the charger light up red at scheduled times, indicating the workspace is blocked and cannot be used.": "Select this mode to make the charger light up red when the workspace is blocked or reserved, indicating that it cannot be used.",
  "Select this mode to workspaces to make the charger light up blue at scheduled times if it was used, indicating these workspaces need to be cleaned.": "Select this mode to workspaces to make the charger light up blue at scheduled times if it was used, indicating these workspaces need to be cleaned.",
  "Select workspace": "Select workspace",
  "Selected workspaces": "Selected workspaces",
  "Send invitation": "Send invitation",
  "Sensor": "Sensor",
  "Sensor and led disconnected": "Sensor and led disconnected",
  "Sensor and ledring is missing or not installed correctly": "Sensor and ledring is missing or not installed correctly",
  "Sensor connection could not be verified": "Sensor connection could not be verified",
  "Sensor details": "Sensor details",
  "Sensor disconnected": "Sensor disconnected",
  "Sensor does not report occupied": "Sensor does not report occupied",
  "Sensor is missing or not installed correctly": "Sensor is missing or not installed correctly",
  "Sent at": "Sent at",
  "Serial No.": "Serial No.",
  "Serial No./Model": "Serial No./Model",
  "Serial number": "Serial number",
  "Serial number is required": "Serial number is required",
  "Setting": "Setting",
  "Setting a hold time for a workspace type ensures the workspace to hold an occupied status for a set time.": "Setting a hold time for a workspace type ensures the workspace to hold an occupied status for a set time.",
  "Settings": "Settings",
  "Show details": "Show details",
  "Show on floorplan": "Show on floorplan",
  "Show working hours only": "Show working hours only",
  "Sign in": "Sign in",
  "Sign in failed": "Sign in failed",
  "Sign out": "Sign out",
  "Sign up": "Sign up",
  "Sign up failed": "Sign up failed",
  "Signal quality": "Signal quality",
  "Signal strength is low": "Signal strength is low",
  "SIM": "SIM",
  "SIM is required": "SIM is required",
  "Skip": "Skip",
  "Something went wrong reading the charger data. Please try again.": "Something went wrong reading the charger data. Please try again.",
  "Something went wrong updating the firmware. Please try again.": "Something went wrong updating the firmware. Please try again.",
  "Something went wrong while starting up bluetooth. Please try again.": "Something went wrong while starting up bluetooth. Please try again.",
  "Something went wrong writing the charger data. Please try again.": "Something went wrong writing the charger data. Please try again.",
  "Sound-proof": "Sound-proof",
  "Start": "Start",
  "Start test": "Start test",
  "Starting firmware update": "Starting firmware update",
  "Starting test": "Starting test",
  "Status": "Status",
  "Stop": "Stop",
  "Submit": "Submit",
  "Sunday": "Sunday",
  "SVG files only to ensure scalability": "SVG files only to ensure scalability",
  "Sync": "Sync",
  "Sync issue": "Sync issue",
  "Sync status": "Sync status",
  "Synchronization": "Synchronization",
  "Take a photo": "Take a photo",
  "Test": "Test",
  "Test aborted at bluetooth ranging": "Test aborted at bluetooth ranging",
  "Test aborted at bluetooth scanning": "Test aborted at bluetooth scanning",
  "Test aborted at startup": "Test aborted at startup",
  "Test aborted before charging": "Test aborted before charging",
  "Test aborted before start": "Test aborted before start",
  "Test aborted during reading characteristics": "Test aborted during reading characteristics",
  "Test completed succesful": "Test completed succesful",
  "Test device": "Test device",
  "Test failed": "Test failed",
  "Test not started": "Test not started",
  "Test the functionality of the device": "Test the functionality of the device",
  "The average percentage of workspaces that have been occupied {{period}} is {{value}}%.": "The average percentage of workspaces that have been occupied {{period}} is {{value}}%.",
  "The charger beacon was not found. Please try again.": "The charger beacon was not found. Please try again.",
  "The charger found does not match the tested device. Verify that the selected device is correct and try again.": "The charger found does not match the tested device. Verify that the selected device is correct and try again.",
  "The charger is not attached to the network. Please try again.": "The charger is not attached to the network. Please try again.",
  "The charger sensor is not connected. Verify the sensor cable connection and try again.": "The charger sensor is not connected. Verify the sensor cable connection and try again.",
  "The device has been disconnected for at least 2 hours.": "The device has been disconnected for at least 2 hours.",
  "The device has been non-functional for 24 hours or more.": "The device has been non-functional for 24 hours or more.",
  "The device has never established a connection.": "The device has never established a connection.",
  "The device is connected and functioning correctly.": "The device is connected and functioning correctly.",
  "The language of the email that will be sent to this user": "The language of the email that will be sent to this user",
  "The location of the device": "The location of the device",
  "The location of the workspace": "The location of the workspace",
  "The names of the workspaces that are located on this floor": "The names of the workspaces that are located on this floor",
  "The percentage that the workspace has been used over the selected period of time": "The percentage that the workspace has been used over the selected period of time",
  "The received charger data is incorrect. Please try again.": "The received charger data is incorrect. Please try again.",
  "The role a user has in the application": "The role a user has in the application",
  "The serial number of the device": "The serial number of the device",
  "The type of the workspace": "The type of the workspace",
  "The workspace names that are located in this company ": "The workspace names that are located in this company ",
  "The workspace where the product is installed": "The workspace where the product is installed",
  "There are in total {{count}} workspaces in this building._one": "There is in total {{count}} workspace in this building.",
  "There are in total {{count}} workspaces in this building._other": "There are in total {{count}} workspaces in this building.",
  "There are in total {{count}} workspaces on this floor._one": "There is in total {{count}} workspace on this floor.",
  "There are in total {{count}} workspaces on this floor._other": "There are in total {{count}} workspaces on this floor.",
  "There are no devices connected to this workspace yet.": "There are no devices connected to this workspace yet.",
  "There are no log messages yet.": "There are no log messages yet.",
  "There are no workspaces added to this floor yet. Select the black plus-button above to add new workspaces. Adding workspaces will affect pages and features that use workspaces.": "There are no workspaces added to this floor yet. Select the black plus-button above to add new workspaces. Adding workspaces will affect pages and features that use workspaces.",
  "There are no workspaces added to this zone yet.": "There are no workspaces added to this zone yet.",
  "There is no company available for you yet. Ask your administrator to provide access via the user management environment.": "There is no company available for you yet. Ask your administrator to provide access via the user management environment.",
  "There is no map for this floor yet. Add a map to specify your floor layout.": "There is no map for this floor yet. Add a map to specify your floor layout.",
  "There is nothing here yet. Navigate to Company tab to add a floorplan.": "There is nothing here yet. Navigate to Company tab to add a floorplan.",
  "There's nothing here yet": "There's nothing here yet",
  "These preferences apply to all users on this account.": "These preferences apply to all users on this account.",
  "These preferences only apply to you.": "These preferences only apply to you.",
  "This charger is already installed on another workspace": "This charger is already installed on another workspace",
  "This month": "This month",
  "This week": "This week",
  "This workspace is not yet part of a workspace zone.": "This workspace is not yet part of a workspace zone.",
  "This year": "This year",
  "Thursday": "Thursday",
  "Time schedule": "Time schedule",
  "Timestamp provided by device that indicates the moment in which information was obtained (event sample time).": "Timestamp provided by device that indicates the moment in which information was obtained (event sample time).",
  "Timestamp that indicates the moment in which the information was received (cloud receive time of event).": "Timestamp that indicates the moment in which the information was received (cloud receive time of event).",
  "Timezone": "Timezone",
  "To": "To",
  "Today": "Today",
  "Tomorrow": "Tomorrow",
  "Total workspaces": "Total workspaces",
  "Transfer": "Transfer",
  "Transfer details": "Transfer details",
  "Transfer device": "Transfer device",
  "Transfer device to": "Transfer device to",
  "Trends": "Trends",
  "Troubles installing the charger? Read the installation instructions.": "Troubles installing the charger? Read the installation instructions.",
  "Try adjusting search or filter to find what you're looking for.": "Try adjusting search or filter to find what you're looking for.",
  "Tuesday": "Tuesday",
  "Type": "Type",
  "Types per page": "Types per page",
  "Uninstall device": "Uninstall device",
  "Uninstall device from workspace": "Uninstall device from workspace",
  "Unknown": "Unknown",
  "Unknown charger": "Unknown charger",
  "Unplugged": "Unplugged",
  "Unused workspaces": "Unused workspaces",
  "Update": "Update",
  "Update the firmware of the device": "Update the firmware of the device",
  "Update workspaces": "Update workspaces",
  "Updated {{date}}": "Updated {{date}}",
  "Updating": "Updating",
  "Updating firmware": "Updating firmware",
  "Upload a base image that only include walls, doors and non-moving objects": "Upload a base image that only include walls, doors and non-moving objects",
  "Upload an image": "Upload an image",
  "Upload floorplan": "Upload floorplan",
  "Uploading firmware": "Uploading firmware",
  "Use {{key}} + C to copy and {{key}} + V to paste workspaces.": "Use {{key}} + C to copy and {{key}} + V to paste workspaces.",
  "Use location address for this building": "Use location address for this building",
  "Use Shift key during rotation for custom angles.": "Use Shift key during rotation for custom angles.",
  "Use the slider to select the time slots on which your schedule is active.": "Use the slider to select the time slots on which your schedule is active.",
  "User could not be removed from this company": "User could not be removed from this company",
  "User could not be saved": "User could not be saved",
  "User details": "User details",
  "User is succesfully removed from this company": "User is succesfully removed from this company",
  "Users": "Users",
  "Users per page": "Users per page",
  "UUID": "UUID",
  "UUID is required": "UUID is required",
  "V{{version}}": "V{{version}}",
  "Vendor": "Vendor",
  "Version": "Version",
  "View": "View",
  "View all remarks": "View all remarks",
  "View in kiosk mode": "View in kiosk mode",
  "View more": "View more",
  "View only": "View only",
  "View options": "View options",
  "View report": "View report",
  "Viewer": "Viewer",
  "Vitality": "Vitality",
  "Vitality trigger": "Vitality trigger",
  "Vitality trigger active": "Vitality trigger active",
  "Voltage level": "Voltage level",
  "Want to improve workplace vitality?": "Want to improve workplace vitality?",
  "Wednesday": "Wednesday",
  "Week schedule": "Week schedule",
  "Weekday": "Weekday",
  "Weekdays": "Weekdays",
  "Weekend days": "Weekend days",
  "Welcome": "Welcome",
  "Welcome, {{name}}": "Welcome, {{name}}",
  "When a building is added it will be listed here.": "When a building is added it will be listed here.",
  "When a floor is added it will be listed here.": "When a floor is added it will be listed here.",
  "When a location is added it will be listed here.": "When a location is added it will be listed here.",
  "Webhook settings could not be loaded": "Webhook settings could not be loaded",
  "Webhooks": "Webhooks",
  "When a schedule is added it will be listed here.": "When a schedule is added it will be listed here.",
  "Work days": "Work days",
  "Working hours": "Working hours",
  "Workspace": "Workspace",
  "Workspace charging": "Workspace charging",
  "Workspace connectivity status definitions": "Workspace connectivity status definitions",
  "Workspace could not be created": "Workspace could not be created",
  "Workspace could not be deleted": "Workspace could not be deleted",
  "Workspace could not be removed": "Workspace could not be removed",
  "Workspace could not be saved": "Workspace could not be saved",
  "Workspace could not be updated": "Workspace could not be updated",
  "Workspace count": "Workspace count",
  "Workspace details": "Workspace details",
  "Workspace free": "Workspace free",
  "Workspace library": "Workspace library",
  "Workspace library impact notice": "Workspace library impact notice",
  "Workspace name": "Workspace name",
  "Workspace name is required": "Workspace name is required",
  "Workspace not found": "Workspace not found",
  "Workspace occupancy indicates whether a workspace is available or in use. An unknown status means the device is either offline or has reported a sensor malfunction or disconnected sensor.": "Workspace occupancy indicates whether a workspace is available or in use. An unknown status means the device is either offline or has reported a sensor malfunction or disconnected sensor.",
  "Workspace occupied": "Workspace occupied",
  "Workspace occupied and charging": "Workspace occupied and charging",
  "Workspace status": "Workspace status",
  "Workspace type": "Workspace type",
  "Workspace type_one": "Workspace type",
  "Workspace type_other": "Workspace types",
  "Workspace type could not be created": "Workspace type could not be created",
  "Workspace type could not be deleted": "Workspace type could not be deleted",
  "Workspace type could not be updated": "Workspace type could not be updated",
  "Workspace type is required": "Workspace type is required",
  "Workspace type name": "Workspace type name",
  "Workspace type name is required": "Workspace type name is required",
  "Workspace type was created successfully": "Workspace type was created successfully",
  "Workspace type was deleted successfully": "Workspace type was deleted successfully",
  "Workspace type was updated successfully": "Workspace type was updated successfully",
  "Workspace types": "Workspace types",
  "Workspace was created successfully": "Workspace was created successfully",
  "Workspace was deleted successfully": "Workspace was deleted successfully",
  "Workspace was removed from zone succesfully": "Workspace was removed from zone succesfully",
  "Workspace was removed successfully": "Workspace was removed successfully",
  "Workspace was updated successfully": "Workspace was updated successfully",
  "Workspaces": "Workspaces",
  "Workspaces added to zone succesfully": "Workspaces added to zone succesfully",
  "Workspaces could not be added": "Workspaces could not be added",
  "Workspaces could not be duplicated": "Workspaces could not be duplicated",
  "Workspaces could not be updated": "Workspaces could not be updated",
  "Workspaces duplicated successfully": "Workspaces duplicated successfully",
  "Workspaces per page": "Workspaces per page",
  "Workspaces succesfully updated": "Workspaces succesfully updated",
  "Yes": "Yes",
  "Yesterday": "Yesterday",
  "You are about to delete this {{entity}} permanently. This action cannot be undone.": "You are about to delete this {{entity}} permanently. This action cannot be undone.",
  "You are about to remove the device from the workspace. The device will have no location anymore. This action can only be reversed by reinstallation with the commissioining app.": "You are about to remove the device from the workspace. The device will have no location anymore. This action can only be reversed by reinstallation with the commissioining app.",
  "You are about to remove the user from this specific company. The user will maintain their access to different companies if applicable. If the user added or adjusted any schedules or zones, their icon will be changed to 'unknown user' and can thus not be traced back to this user. This action cannot be undone.": "You are about to remove the user from this specific company. The user will maintain their access to different companies if applicable. If the user added or adjusted any schedules or zones, their icon will be changed to 'unknown user' and can thus not be traced back to this user. This action cannot be undone.",
  "You are currently in a different timezone than the location you are viewing. The data presented here is based on the timezone of the location.": "You are currently in a different timezone than the location you are viewing. The data presented here is based on the timezone of the location.",
  "You don't have any projects yet. Please contact your administrator to get started.": "You don't have any projects yet. Please contact your administrator to get started.",
  "Your current password is required": "Your current password is required",
  "Your email address is <1>{{email}}</1>": "Your email address is <1>{{email}}</1>",
  "Your chats": "Your chats",
  "Zip/Postal code": "Zip/Postal code",
  "Zip/Postal code is required": "Zip/Postal code is required",
  "Zone": "Zone",
  "Zone could not be created": "Zone could not be created",
  "Zone could not be deleted": "Zone could not be deleted",
  "Zone could not be saved": "Zone could not be saved",
  "Zone details": "Zone details",
  "Zone is required": "Zone is required",
  "Zone name": "Zone name",
  "Zone name is required": "Zone name is required",
  "Zone was created successfully": "Zone was created successfully",
  "Zone was deleted successfully": "Zone was deleted successfully",
  "Zone was updated successfully": "Zone was updated successfully",
  "Zones": "Zones",
  "Zones per page": "Zones per page",
  "AI Data Assistant": "AI Data Assistant",
  "Ask me anything about your workspace data. I can help you analyze occupancy, trends, and more.": "Ask me anything about your workspace data. I can help you analyze occupancy, trends, and more.",
  "I'm your digital assistant. Check the full [user guide](/companies/{{companyId}}/assistant/guide) for more details.": "I'm your digital assistant. Check the full [user guide](/companies/{{companyId}}/assistant/guide) for more details.",
  "Hi, I'm your AI Data Assistant. I can help you with:\n- Retrieving occupancy data for buildings, floors, zones and workspaces\n- Creating reports with custom layouts, time ranges and granularity\n- Answering follow-up questions about your results\n\nI cannot draw conclusions, give recommendations, or provide employee information.\n\nFor tips, examples and more details, check the full [user guide](/companies/{{companyId}}/assistant/guide).": "Hi, I'm your AI Data Assistant. I can help you with:\n- Retrieving occupancy data for buildings, floors, zones and workspaces\n- Creating reports with custom layouts, time ranges and granularity\n- Answering follow-up questions about your results\n\nI cannot draw conclusions, give recommendations, or provide employee information.\n\nFor tips, examples and more details, check the full [user guide](/companies/{{companyId}}/assistant/guide).",
  "Type your question...": "Type your question...",
  "Cancel request": "Cancel request",
  "Preview": "Preview",
  "Expand preview": "Expand preview",
  "Download report": "Download report",
  "Download full report": "Download full report",
  "Report is still generating": "Report is still generating",
  "Loading preview...": "Loading preview...",
  "Preview unavailable": "Preview unavailable",
  "Unable to load preview.": "Unable to load preview.",
  "* Preview is limited to the first {{rows}} rows and {{columns}} columns": "* Preview is limited to the first {{rows}} rows and {{columns}} columns",
  "Failed to get response. Please try again.": "Failed to get response. Please try again.",
  "No conversations yet": "No conversations yet",
  "Select chats to delete": "Select chats to delete",
  "Delete": "Delete",
  "Delete {{count}} chats? This action cannot be undone.": "Delete {{count}} chats? This action cannot be undone.",
  "+ New": "+ New",
  "User Guide": "User Guide",
  "Contents": "Contents",
  "What is AI Data Assistant": "What is AI Data Assistant",
  "What problem it solves": "What problem it solves",
  "How it works": "How it works",
  "What it can do": "What it can do",
  "What it cannot do": "What it cannot do",
  "Important to know": "Important to know",
  "Tips and tricks": "Tips and tricks",
  "Examples of user requests": "Examples of user requests",
  "FAQ": "FAQ",
  "The AI Data Assistant is software designed to support users in accessing and understanding their company's data through natural language interaction. The chatbot acts as an intelligent interface between users and underlying data sources.": "The AI Data Assistant is software designed to support users in accessing and understanding their company's data through natural language interaction. The chatbot acts as an intelligent interface between users and underlying data sources.",
  "The AI Data Assistant makes it possible for users to have full access to the data of their company while not requiring any knowledge of databases and technologies to retrieve that data. It helps users quickly find and export the data in a report in the layout they want without needing technical expertise or support from data teams. Users can get data in granularity, time ranges and combinations that are not available in the DMS interface.": "The AI Data Assistant makes it possible for users to have full access to the data of their company while not requiring any knowledge of databases and technologies to retrieve that data. It helps users quickly find and export the data in a report in the layout they want without needing technical expertise or support from data teams. Users can get data in granularity, time ranges and combinations that are not available in the DMS interface.",
  "1. You ask a question in your language\nNo technical skills needed. Just type what you want to know in regard to your company's data.\nCheck out ": "1. You ask a question in your language\nNo technical skills needed. Just type what you want to know in regard to your company's data.\nCheck out ",
  " to see how to get the best out of your questions.": " to see how to get the best out of your questions.",
  "2. The assistant processes your question\nIt asks for clarifications if needed, then with the help of AI translates your question into a structured database query, runs it and returns results instantly.": "2. The assistant processes your question\nIt asks for clarifications if needed, then with the help of AI translates your question into a structured database query, runs it and returns results instantly.",
  "3. You receive a downloadable report\nResults are delivered in an excel report\nThe assistant provides explanations of the columns and rows in this report\nPreview is available directly in the chat": "3. You receive a downloadable report\nResults are delivered in an excel report\nThe assistant provides explanations of the columns and rows in this report\nPreview is available directly in the chat",
  "4. Explains the results\nYou can ask follow-up questions to better understand the data or refine your request.": "4. Explains the results\nYou can ask follow-up questions to better understand the data or refine your request.",
  "5. Keeps your work organized\nSaves all chats automatically\nEasy overview of past queries\nSelect, manage, or delete conversations": "5. Keeps your work organized\nSaves all chats automatically\nEasy overview of past queries\nSelect, manage, or delete conversations",
  "- Retrieve data as requested.\n- Present the data in the layout you request. For example, you can ask to have the dates in rows or in columns.\n- Explain the data and answer follow-up clarifying questions.": "- Retrieve data as requested.\n- Present the data in the layout you request. For example, you can ask to have the dates in rows or in columns.\n- Explain the data and answer follow-up clarifying questions.",
  "- Provide conclusions or recommendations based on the data.\n- Provide information about the employees of the company, but only about the occupancy data generated by them.": "- Provide conclusions or recommendations based on the data.\n- Provide information about the employees of the company, but only about the occupancy data generated by them.",
  "- The system is designed to answer only occupancy-related questions\n- It's primarily a data retrieval tool, not a data analysis tool\n- It's not designed to give conclusions or recommendations\n- The final output is always an excel report with data in columns and rows\n- It stores occupancy data per quarter. You cannot request data for minutes\n- By default the system always assumes days Monday-Friday and working hours of your company.\n  If you need data for weekends or outside working hours, you need to specify it in your request.": "- The system is designed to answer only occupancy-related questions\n- It's primarily a data retrieval tool, not a data analysis tool\n- It's not designed to give conclusions or recommendations\n- The final output is always an excel report with data in columns and rows\n- It stores occupancy data per quarter. You cannot request data for minutes\n- By default the system always assumes days Monday-Friday and working hours of your company.\n  If you need data for weekends or outside working hours, you need to specify it in your request.",
  "1. As with all AI tools, be as specific as possible. The less general the request, the less the AI has to guess.": "1. As with all AI tools, be as specific as possible. The less general the request, the less the AI has to guess.",
  "2. If you know what you want in columns and what in rows of your report, say it to the assistant.\nFor example: \"Show me average occupancy per workspace per hour on floor 3 for the last month. Show workspaces in rows and hours in columns\".": "2. If you know what you want in columns and what in rows of your report, say it to the assistant.\nFor example: \"Show me average occupancy per workspace per hour on floor 3 for the last month. Show workspaces in rows and hours in columns\".",
  "3. The output results should not be more than 4,000,000 rows and 3,000 columns. For example, if you want to see occupancy per quarter-hour in columns, make sure that you don't request more than a month, which would be 96 x 31 = 2,974 columns for a whole day + weekends.": "3. The output results should not be more than 4,000,000 rows and 3,000 columns. For example, if you want to see occupancy per quarter-hour in columns, make sure that you don't request more than a month, which would be 96 x 31 = 2,974 columns for a whole day + weekends.",
  "4. If you want to know about peak occupancy, the system will calculate it by finding the quarter of an hour with the highest occupancy per unit you are requesting (it can be for a floor, a building, a weekday etc.)": "4. If you want to know about peak occupancy, the system will calculate it by finding the quarter of an hour with the highest occupancy per unit you are requesting (it can be for a floor, a building, a weekday etc.)",
  "5. If you want to have a composite column like this 2026-03-02 09:00, or like this 2026-03-02 00:00-00:15, you can use the \"+\" sign like here: \"put date+hour into columns\".": "5. If you want to have a composite column like this 2026-03-02 09:00, or like this 2026-03-02 00:00-00:15, you can use the \"+\" sign like here: \"put date+hour into columns\".",
  "6. Use these terms in your requests to help the AI better understand what you want: average occupancy, peak occupancy, quarterly, daily, hourly, weekly, monthly, yearly, workspace or desk, location, building, floor, zone.": "6. Use these terms in your requests to help the AI better understand what you want: average occupancy, peak occupancy, quarterly, daily, hourly, weekly, monthly, yearly, workspace or desk, location, building, floor, zone.",
  "- \"Show me average occupancy per building for the last 30 days.\"\n- \"Show me peak occupancy per floor per weekday for the last quarter.\"\n- \"Give me occupancy per workspace every 15 minutes for yesterday. Show workspaces in rows and time slots in columns.\"\n- \"Compare the average occupancy of Building A and Building B for the last month.\"\n- \"Show me daily occupancy for floor 3 for the last 12 weeks.\"\n- \"Show me average occupancy of zone Z1 per hour on Mondays and Tuesdays for the last 3 months.\"": "- \"Show me average occupancy per building for the last 30 days.\"\n- \"Show me peak occupancy per floor per weekday for the last quarter.\"\n- \"Give me occupancy per workspace every 15 minutes for yesterday. Show workspaces in rows and time slots in columns.\"\n- \"Compare the average occupancy of Building A and Building B for the last month.\"\n- \"Show me daily occupancy for floor 3 for the last 12 weeks.\"\n- \"Show me average occupancy of zone Z1 per hour on Mondays and Tuesdays for the last 3 months.\"",
  "Q: What kind of questions can I ask?": "Q: What kind of questions can I ask?",
  "\nA: You can ask any question related to workspace and building occupancy data — average occupancy, peak occupancy, utilization per floor, zone, building, or workspace, filtered by time range, weekday, or hour.\n\n": "\nA: You can ask any question related to workspace and building occupancy data — average occupancy, peak occupancy, utilization per floor, zone, building, or workspace, filtered by time range, weekday, or hour.\n\n",
  "Q: Can it answer questions not related to occupancy?": "Q: Can it answer questions not related to occupancy?",
  "\nA: No. The assistant is designed exclusively for occupancy-related data queries. Questions about weather, general knowledge, or other unrelated topics will not be answered.\n\n": "\nA: No. The assistant is designed exclusively for occupancy-related data queries. Questions about weather, general knowledge, or other unrelated topics will not be answered.\n\n",
  "Q: What is the finest level of detail I can get?": "Q: What is the finest level of detail I can get?",
  "\nA: The system stores data per quarter of an hour (15-minute intervals). You can request data at daily, hourly, or quarter-hour granularity.\n\n": "\nA: The system stores data per quarter of an hour (15-minute intervals). You can request data at daily, hourly, or quarter-hour granularity.\n\n",
  "Q: Can I get data for today?": "Q: Can I get data for today?",
  "\nA: No. Today's data is not yet available. The most recent data is from yesterday.\n\n": "\nA: No. Today's data is not yet available. The most recent data is from yesterday.\n\n",
  "Q: Does the assistant apply working hours and weekday filters by default?": "Q: Does the assistant apply working hours and weekday filters by default?",
  "\nA: Yes. By default, results include only Monday–Friday during your company's configured working hours. If you need weekends or hours outside of working hours, specify it explicitly in your request.\n\n": "\nA: Yes. By default, results include only Monday–Friday during your company's configured working hours. If you need weekends or hours outside of working hours, specify it explicitly in your request.\n\n",
  "Q: Are there size limits for the output?": "Q: Are there size limits for the output?",
  "\nA: Yes. The maximum output is 4,000,000 rows and 3,000 columns. If your request would exceed these limits, you will be asked to narrow it down.\n\n": "\nA: Yes. The maximum output is 4,000,000 rows and 3,000 columns. If your request would exceed these limits, you will be asked to narrow it down.\n\n",
  "Q: What happens if my question is unclear?": "Q: What happens if my question is unclear?",
  "\nA: The assistant will ask clarification questions before proceeding. It will also confirm its understanding of your request before generating the report.\n\n": "\nA: The assistant will ask clarification questions before proceeding. It will also confirm its understanding of your request before generating the report.\n\n",
  "Q: Can the assistant draw conclusions from the data?": "Q: Can the assistant draw conclusions from the data?",
  "\nA: No. It retrieves and presents data, but does not provide analysis, conclusions, or recommendations.\n\n": "\nA: No. It retrieves and presents data, but does not provide analysis, conclusions, or recommendations.\n\n",
  "Q: Can I choose how the report is laid out?": "Q: Can I choose how the report is laid out?",
  "\nA: Yes. You can specify what goes in rows and what goes in columns. For example, you can ask for workspaces in rows and hours in columns, or vice versa.\n\n": "\nA: Yes. You can specify what goes in rows and what goes in columns. For example, you can ask for workspaces in rows and hours in columns, or vice versa.\n\n",
  "Q: Can I get information about employees?": "Q: Can I get information about employees?",
  "\nA: No. The system only works with occupancy data generated by sensors. It does not store or provide any personal employee information.": "\nA: No. The system only works with occupancy data generated by sensors. It does not store or provide any personal employee information.",
  "Unlimited": "Unlimited",
  "Premium tier": "Premium",
  "Free tier": "Free",
  "{{remaining}} / {{total}} credits remaining": "{{remaining}} / {{total}} credits remaining",
  "Remaining chatbot credits": "Remaining chatbot credits",
  "Loading plan...": "Loading plan...",
  "Retry loading plan": "Retry loading plan",
  "Plan unavailable. Retry": "Plan unavailable. Retry",
  "Your chatbot credits are exhausted. Please contact the support team for assistance.": "Your chatbot credits are exhausted. Please contact the support team for assistance.",
  "No chatbot credits remaining. Upgrade to premium or wait for the credits to reset on the first day of next month (UTC).": "No chatbot credits remaining. Upgrade to premium or wait for the credits to reset on the first day of next month (UTC).",
  "Another request is in progress for your company. Please try again shortly.": "Another request is in progress for your company. Please try again shortly.",
  "Subscriptions": "Subscriptions",
  "No subscriptions": "No subscriptions",
  "Not subscribed": "Not subscribed",
  "Subscriptions could not be loaded": "Subscriptions could not be loaded",
  "Subscriptions were updated successfully": "Subscriptions were updated successfully",
  "Subscriptions could not be saved": "Subscriptions could not be saved",
  "Only system administrators can edit subscriptions": "Only system administrators can edit subscriptions",
  "Choose a plan for each feature. Changes apply to this company.": "Choose a plan for each feature. Changes apply to this company.",
  "Plan for {{feature}}": "Plan for {{feature}}",
  "No subscription features available": "No subscription features available",
  "Occupancy colors": "Occupancy colors",
  "Not configured": "Not configured",
  "Occupancy colors were updated successfully": "Occupancy colors were updated successfully",
  "Occupancy colors could not be saved": "Occupancy colors could not be saved",
  "Red": "Red",
  "Blue": "Blue",
  "Orange": "Orange",
  "Yellow": "Yellow",
  "Purple": "Purple",
  "Green": "Green",
  "White": "White",
  "Regular sync settings were updated successfully": "Regular sync settings were updated successfully",
  "Regular sync settings could not be saved": "Regular sync settings could not be saved",
  "Enabled": "Enabled",
  "Disabled": "Disabled",
  "Occupancy colors on device": "Occupancy colors on device"
}
